import { render, staticRenderFns } from "./BatteryGridSettings.vue?vue&type=template&id=195cef73&"
import script from "./BatteryGridSettings.vue?vue&type=script&lang=ts&"
export * from "./BatteryGridSettings.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports